import CrudCustom from '../../../libs/custom/CrudCustom';

let PtkpService = new CrudCustom('/ptkps');
export default PtkpService;
